<template>
  <v-container>
    <ScreenLoading :show="showLoading" />
    <v-row class="title text-h5 text-uppercase">
      <v-icon>fa-qrcode</v-icon> &nbsp;
      {{ editPage ? $t('index.titleEdit') : $t('index.titleSearch') }}
    </v-row>
    <v-row class="content max-width">
      <ScanRecordSearch
        v-show="!editPage"
        :scan-record-list="scanRecordList"
        @search="search($event)"
        @add="add($event)"
        @detail="detail($event)"
        @del="del($event)"
        @clear="clear($event)"
      />
    </v-row>
  </v-container>
</template>

<i18n src="./locales/en.json"></i18n>
<i18n src="./locales/zhHant.json"></i18n>

<script>
import ScanRecordSearch from './M0301ScanRecordSearch.vue'
import ErrorDisplay from '@/components/functions/Common/mixins/ErrorDisplay'
import ScreenLoading from '@/base/components/atoms/AtScreenLoading'

export default {
  name: 'ScanRecordIndex',
  components: {
    ScanRecordSearch,
    ScreenLoading
  },
  mixins: [ErrorDisplay],
  data: function () {
    return {
      showLoading: false,
      editPage: false
    }
  },
  computed: {
    scanRecordList () {
      return this.$store.state.M0301ScanRecord.scanRecordList
    }
  },
  mounted () {
    this.$emit('pageName', this.$t('pageName'))
  },
  methods: {
    search (event) {
      this.showLoading = true
      this.$store.dispatch('M0301ScanRecord/search', event)
        .then(() => {
          this.showLoading = false
        }).catch((err) => {
          this.showLoading = false
          this.showError(err)
        })
    },
    add (event) {

    },
    detail (event) {
      this.showLoading = true
      this.$store.dispatch('M0001AdminUser/detail', { id: event.id })
        .then(() => {
          this.showLoading = false
          this.editPage = true
        }).catch((err) => {
          this.showLoading = false
          this.showError(err)
        })
    },
    del (event) {

    },
    clear (event) {
      this.$store.dispatch('M0301ScanRecord/clear')
    }
  }
}
</script>

<style scoped>
.title, .content {
  margin: 20px;
}

.max-width {
  width: 100%
}
</style>
